import { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import VerificaToken from "../../components/utils/VerificaToken";
import "./Categorias.css";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import CategoriaBanner from "./CategoriaBanner/CategoriaBanner";

export default function Categorias() {

  const [ordenacao, setOrdenacao] = useState("alfabetica");

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    login: false,
    codcliente: null,
    tipo: "",
  });

  // 🔹 Produtos e grupos
  const [produtos, setProdutos] = useState([]);
  const [grupos, setGrupos] = useState({ grupos: [], subgrupos: [] });
  const [loadingProdutos, setLoadingProdutos] = useState(true);

  // Pega o codgrupo da URL
  const { codgrupo } = useParams();
  const [searchParams] = useSearchParams();

  const codgrupoNumber = Number(codgrupo);
  const codsubgrupo = searchParams.get("subgrupo");
  const codsubgrupoNumber = codsubgrupo ? Number(codsubgrupo) : null;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);


  useEffect(() => {
    async function verificar() {
      const dados = await VerificaToken();
      setUsuario(dados);
    }

    verificar();
  }, []);

  const ehCNPJ = usuario.login && usuario.tipo === "CNPJ";

  // 🔹 Carregar produtos por grupo/subgrupo
  useEffect(() => {
    async function carregarProdutos() {
      setLoadingProdutos(true);
      try {

        const body = {
          codgrupo: codgrupoNumber,
        };

        if (codsubgrupoNumber) {
          body.codsubgrupo = codsubgrupoNumber;
        }

        if (ehCNPJ) {
          body.codcliente = usuario.codcliente;
        }

       // console.log("Body enviado:", body);

        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/busca/listar-produtos-por-grupo",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          }
        );

        const data = await response.json();
       // console.log("produtos", data)

        setProdutos(data.produtos);

        // Atualiza estado de grupos e subgrupos
        setGrupos({
          grupos: data.grupos?.grupos || [],
          subgrupos: data.grupos?.subgrupos || [],
        });
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingProdutos(false);
      }
    }

    if (codgrupoNumber) carregarProdutos();
  }, [
    codgrupoNumber,
    codsubgrupoNumber,
    ehCNPJ,
    usuario.codcliente,
  ]);

  // Pegando descrições
  const grupoAtual = grupos.grupos[0]?.descricao || null;
  const subgrupoAtual = grupos.subgrupos[0]?.descricao || null;


  const produtosOrdenados = useMemo(() => {
  const lista = [...produtos];

  switch (ordenacao) {
    case "menor-preco":
      lista.sort((a, b) => {
        const precoA =
          ehCNPJ && a.valorunitario != null
            ? Number(a.valorunitario)
            : Number(a.precovenda);

        const precoB =
          ehCNPJ && b.valorunitario != null
            ? Number(b.valorunitario)
            : Number(b.precovenda);

        return precoA - precoB;
      });
      break;

    case "maior-preco":
      lista.sort((a, b) => {
        const precoA =
          ehCNPJ && a.valorunitario != null
            ? Number(a.valorunitario)
            : Number(a.precovenda);

        const precoB =
          ehCNPJ && b.valorunitario != null
            ? Number(b.valorunitario)
            : Number(b.precovenda);

        return precoB - precoA;
      });
      break;

    default:
      lista.sort((a, b) =>
        a.Descricao.localeCompare(
          b.Descricao,
          "pt-BR",
          { sensitivity: "base" }
        )
      );
  }

  return lista;
}, [produtos, ordenacao, ehCNPJ]);

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <CategoriaBanner codgrupo={codgrupoNumber} />

      <div className="categori-link-left">
        <a href="/" className="breadcrumb-link">
          Início
        </a>
        <span className="breadcrumb-separator">›</span>
        <div className="breadcrumb-current">Categorias</div>
      </div>

      {/* CONTEÚDO */}
      <div className="categoria-wrapper">
        {/* TÍTULO */}
        <section className="categoria-title">
          {grupoAtual && <h1>Categoria: {grupoAtual}</h1>}
          {subgrupoAtual && <h2>Subgrupo: {subgrupoAtual}</h2>}
        </section>

        {/* TOPO RESULTADO */}
        <div className="categoria-resultado-topo">
          <div>
            <span>{produtos.length} produtos encontrados</span>
          </div>

          <div className="categoria-resultado-acoes">
            <span>Ordenar por:</span>
            <select
  className="categoria-ordenar-select"
  value={ordenacao}
  onChange={(e) => setOrdenacao(e.target.value)}
>
  <option value="alfabetica">
    Ordem alfabética
  </option>

  <option value="menor-preco">
    Menor preço
  </option>

  <option value="maior-preco">
    Maior preço
  </option>
</select>
          </div>
        </div>

        {/* PRODUTOS */}
        <section className="categoria-products">
          {loadingProdutos ? (
            <p>Carregando produtos...</p>
          ) : produtos.length === 0 ? (
            <p>Nenhum produto encontrado</p>
          ) : (
            produtosOrdenados.map((produto) => (
              <div
                className="categoria-product-card"
                key={produto.CodItem}
                onClick={() => navigate(`/cardproduto/${produto.CodItem}`)}
              >
                {produto.foto ? (
                  <img src={produto.foto} alt={produto.Descricao} />
                ) : (
                  <div className="categoria-product-img-placeholder" />
                )}

                <div className="categoria-produto-meta">
                  {produto.quantemb} Kg - Cód. {produto.CodItem}
                </div>

                <h3>
                  {produto.Descricao?.length > 36
                    ? `${produto.Descricao.slice(0, 36).trim().replace(/\s+\S*$/, "")}...`
                    : produto.Descricao}
                </h3>
                {Number(produto.corrigepreco) === 1 && (
                  <span>Peso variável</span>
                )}




                {usuario.login && (
                  <div className="categoria-precos">
                    {ehCNPJ ? (
                      produto.valorunitario != null &&
                        Number(produto.valorunitario) < Number(produto.precovenda) ? (
                        <>
                          <div className="categoria-preco-antigo">
                            R$ {Number(produto.precovenda).toFixed(2)}
                          </div>

                          <div className="categoria-preco-desconto">
                            R$ {Number(produto.valorunitario).toFixed(2)}
                          </div>
                        </>
                      ) : (
                        <div className="categoria-preco-desconto">
                          R$ {Number(produto.precovenda).toFixed(2)}
                        </div>
                      )
                    ) : (
                      <div className="categoria-preco-normal">
                        R$ {Number(produto.precovenda).toFixed(2)}
                      </div>
                    )}
                  </div>
                )}



                <button
                  onClick={() => navigate(`/cardproduto/${produto.CodItem}`)}
                >
                  Ver produto
                </button>
              </div>
            ))
          )}
        </section>
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
